import { render, staticRenderFns } from "./GestioneHeader.vue?vue&type=template&id=39197c41&scoped=true&"
import script from "./GestioneHeader.vue?vue&type=script&lang=js&"
export * from "./GestioneHeader.vue?vue&type=script&lang=js&"
import style0 from "./GestioneHeader.vue?vue&type=style&index=0&id=39197c41&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39197c41",
  null
  
)

export default component.exports